'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Gromit = require('../Gromit');

var _Gromit2 = _interopRequireDefault(_Gromit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Executes a graphql request
 * @callback GraphqlRequester
 * @param {string} query - The graphql query string
 * @param {Object} variables - variables to add to the query
 * @return {Promise<Object>} a promise that resolves to the Graphql response data
 *
 */

/**
 * Fetch an authorization token
 * @callback TokenGetter
 * @return {Promise<string>} The token future
 */

/**
 *
 * Make a grapqhl request.
 * @function graphqlRequest
 * @param {string} url - The url to request
 * @param {TokenGetter} getToken - A function returning a promise that will resolve to a new token that will be placed in the Authorization header
 * @return {GraphqlRequester} - A function that accepts a query string and variables object
 *
 */
exports.default = function (url, getToken) {
  return function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(query, variables) {
      var token;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getToken();

            case 2:
              token = _context.sent;
              return _context.abrupt('return', (0, _Gromit2.default)({ headers: {
                  'Authorization': token
                } }).post(url, { query: query, variables: variables }).then(function (response) {
                return response.data;
              }));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};